import FluxUtils from 'flux/utils';

import ErrorActions from 'sharedreact/actions/ErrorActions';
import ErrorDialog from 'sharedreact/components/ErrorDialog';
import asFunctional from 'sharedreact/components/asFunctional';
import ErrorStore from 'sharedreact/stores/ErrorStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

type Props = {
  language: string
};

type State = ConstructorParameters<typeof ErrorDialog>[0];

function getStores () {
  return [
    ErrorStore
  ];
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  return {
    errors: ErrorStore.getErrors(),
    warnings: ErrorStore.getWarnings(),
    onClearError: ErrorActions.clearError,
    onClearWarning: ErrorActions.clearWarning,

    language: props.language
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(ErrorDialog),
  getStores,
  calculateState,
  { withProps: true }
);
